import ResultsList from './ResultsList';

export default ResultsList;
